'use strict';

import { logger } from "../common/index.js";
export function setGestureState(_handlerTag, _newState) {
  logger.warn('setGestureState() is not available on web.');
}
//# sourceMappingURL=setGestureState.js.map